import { render, staticRenderFns } from "./SelectBox.vue?vue&type=template&id=03a9a7af&"
import script from "./SelectBox.vue?vue&type=script&lang=ts&"
export * from "./SelectBox.vue?vue&type=script&lang=ts&"
import style0 from "./SelectBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/p00353_hh-ballett/client-player/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03a9a7af')) {
      api.createRecord('03a9a7af', component.options)
    } else {
      api.reload('03a9a7af', component.options)
    }
    module.hot.accept("./SelectBox.vue?vue&type=template&id=03a9a7af&", function () {
      api.rerender('03a9a7af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectBox.vue"
export default component.exports